export default __webpack_public_path__ + "static/media/pagebg.a5c68be2.jpg";